// Copyright (c) 2025. CYBERKOALA LLC.
//
// SPDX-License-Identifier: Proprietary License.
//
// Redistribution and use in source and binary forms, with or without
// modification, are restricted.

import { createContext, useContext } from 'react';

export type SettingsContextType = {
  notifications: boolean;
  setNotifications: (checked: boolean) => void;
  speakingNotifications: boolean;
  setSpeakingNotifications: (checked: boolean) => void;
  userStartPlayingNotifications: boolean;
  setUserStartPlayingNotifications: (checked: boolean) => void;
  captureSystemAudio: boolean;
  setCaptureSystemAudio: (value: boolean) => void;
  autoConnectVoice: boolean;
  setAutoConnectVoice: (checked: boolean) => void;
  toggleAutoConnectVoice: () => void;
  audioOutputDevices: MediaDeviceInfo[];
  setAudioOutputDevices: (mediaDeviceInfos: MediaDeviceInfo[]) => void;
  selectedAudioOutputDeviceId: string;
  setSelectedAudioOutputDeviceId: (deviceId: string) => void;
  audioOutputError: string;
  setAudioOutputError: (error: string) => void;
  sfxVolume: number;
  setSFXVolume: (volume: number) => void;
  autoGainControl: boolean;
  setAutoGainControl: (enabled: boolean) => void;
  noiseSuppression: boolean;
  setNoiseSuppression: (enabled: boolean) => void;
  echoCancellation: boolean;
  setEchoCancellation: (enabled: boolean) => void;
  mutedServers: Record<string, boolean>;
  toggleServerMute: (serverId: string) => void;
  spatialAudioEnabled: boolean;
  setSpatialAudioEnabled: (enabled: boolean) => void;
  selectedAudioInputDeviceId: string;
  setSelectedAudioInputDeviceId: (id: string) => void;
  receiveScreenShare: boolean;
  setReceiveScreenShare: (value: boolean) => void;
};

export const SettingsContext = createContext<SettingsContextType>(
  {} as SettingsContextType
);

export const useSettings = () => useContext(SettingsContext);
